// extracted by mini-css-extract-plugin
export default {"tabs":"WhyIsAirQualityImportant_tabs__ILXzg","tabContainer":"WhyIsAirQualityImportant_tabContainer__sIawZ"};